
import "./privacy.css";

import { useState, useEffect} from "react";

const Privacy = () => {
  const [isActive, setIsActive] = useState("#privacy_policy");
  
  const toggleClass = (e:any) => {
    setIsActive(e.currentTarget.hash);
  };

  const toggleAccordion = (e:any) => { 
    let panels = document.getElementById(e?.currentTarget?.id) as HTMLElement;
    panels?.classList?.toggle("activee");
    let panel = panels?.nextElementSibling as HTMLElement;
    if(panel && panel.style.maxHeight){
      panel.style.maxHeight = '';
    }
    else{
      panel.style.maxHeight = panel?.scrollHeight + 'px'
    }
  }


  useEffect(() => {
  }, [])


  const entries:any = performance.getEntriesByType("navigation");
  entries.forEach((entry:any) => {
  if (entry.type === "reload") {
    window.location.href = '/privacy';
  }
});

  return (
    <div className="wrapper">
      <div className="container">
  
        <div id="wbars_all">
          <div className="atl_container atl_base_container">
            <div id="wbars">
              <div className="atl_content legal_pp">
                <div className="atl_header">
                  <h1 id="privacy_policy">
                    <strong>Privacy Policy of Atlas Energy Solutions</strong>
                  </h1>

                  <p>
                    Atlas Energy Solutions collects some Personal Data from its
                    Users.
                  </p>
                  <br />
                  <p>
                    Users may be subject to different protection standards and
                    broader standards may therefore apply to some. In order to
                    learn more about the protection criteria, Users can refer to
                    the applicability section.
                  </p>
                  <p>
                    This document can be printed for reference by using the
                    print command in the settings of any browser.
                  </p>
                </div>
               

                <div className="one_line_col">
                  <h2 id="owner_of_the_data" className="pb-10">Owner and Data Controller</h2>
                  <p>
                    Atlas Energy Solutions ATTN : <strong>VP Technology</strong></p>
                   <p>5918 W Courtyard Dr Suite 500,<br></br>
                    Austin, TX 78730, United States</p>
                  <p>
                    Owner contact email: <a href="mailto:privacy@atlas.energy"><strong>privacy@atlas.energy</strong></a>
                  </p>
                </div>

                <div className="one_line_col">
                  <h2 id="types_of_data" className="pb-10">Types of Data collected</h2>

                  <p>
                    Among the types of Personal Data that Atlas Energy Solutions
                    collects, by itself or through third parties, there are:
                    email address; Usage Data; geographic position; phone
                    number; first name; last name; profession; company name;
                    general activity data; movement activity; unique device
                    identifiers for push notifications; data relating to the
                    point of sale; profile picture; Precise location permission
                    (continuous); Approximate location permission (continuous);
                    Motion sensors permission; password.
                  </p>

                  <p>
                    Complete details on each type of Personal Data collected are
                    provided in the dedicated sections of this privacy policy or
                    by specific explanation texts displayed prior to the Data
                    collection.</p>
                  
                  <p>Personal Data may be freely provided by the User.</p>

                  <h3
                    className="atl-subheading atl-subheading-legal-mode-processing"
                  >
                  Information regarding the Personal details captured :
                  </h3>
                  <p>
                    <strong>First Name : </strong> Need not be the real name of the person . He/she is free to provide any display name he prefers.
                  </p>
                  <p>
                    <strong>Last Name : </strong> Need not be the real last name of the person . He/she is free to provide any name for display name.
                  </p>
                  <p>
                    <strong>Phone Number : </strong> Required if the user is not opting to login using email and password . Only used for authentication purpose.
                  </p>
                  <p>
                    <strong>Email ID :</strong> Can be any Email-Id where user can verify the one time password during registration. This information is not used for any personal details capture or real person identification. 
                  </p>
                  <p>
                    <strong>City :</strong> Not mandatory 
                  </p>
                  <p>
                    <strong>Country </strong> Not mandatory
                  </p>
                  <p>
                    <strong>Surname : </strong> Not mandatory
                  </p>

                  <p>
                    Users who are uncertain about which Personal Data is mandatory are welcome to contact the Owner
                  </p>
                  <p>
                    Atlas Energy does not track or map the real user based on the details collected during registration or any location information collected during app usage.
                  </p>
                  <p>
                    Users are responsible for any third-party Personal Data obtained, published or shared through Atlas Energy Solutions and confirm that they have the third party's consent to provide the Data to the Owner.
                  </p>
                    
                </div>

                <div className="one_line_col">
                  <h2 id="place_of_processing">
                    Mode and place of processing the Data
                  </h2>
                  <h3
                    className="atl-subheading atl-subheading-legal-mode-processing"
                  >
                    Methods of processing
                  </h3>
                  <p>
                    The Owner takes appropriate security measures to prevent
                    unauthorized access, disclosure, modification, or
                    unauthorized destruction of the Data.<br />The Data
                    processing is carried out using computers and/or IT enabled
                    tools, following organizational procedures and modes
                    strictly related to the purposes indicated. In addition to
                    the Owner, in some cases, the Data may be accessible to
                    certain types of persons in charge, involved with the
                    operation of Atlas Energy Solutions (administration, sales,
                    marketing, legal, system administration) or external parties
                    (such as third-party technical service providers, mail
                    carriers, hosting providers, IT companies, communications
                    agencies) appointed, if necessary, as Data Processors by the
                    Owner. The updated list of these parties may be requested
                    from the Owner at any time.
                  </p>
                  <h3
                    className="atl-subheading atl-subheading-legal-basis-of-processing"
                  >
                    Legal basis of processing
                  </h3>
                  <p>
                    The Owner may process Personal Data relating to Users if one
                    of the following applies:
                  </p>
                  <ul>
                    <li>
                      Users have given their consent for one or more specific
                      purposes. Note: Under some legislations the Owner may be
                      allowed to process Personal Data until the User objects to
                      such processing (“opt-out”), without having to rely on
                      consent or any other of the following legal bases. This,
                      however, does not apply, whenever the processing of
                      Personal Data is subject to European data protection law;
                    </li>
                    <li>
                      provision of Data is necessary for the performance of an
                      agreement with the User and/or for any pre-contractual
                      obligations thereof;
                    </li>
                    <li>
                      processing is necessary for compliance with a legal
                      obligation to which the Owner is subject;
                    </li>
                    <li>
                      processing is related to a task that is carried out in the
                      public interest or in the exercise of official authority
                      vested in the Owner;
                    </li>
                    <li>
                      processing is necessary for the purposes of the legitimate
                      interests pursued by the Owner or by a third party.
                    </li>
                  </ul>
                  <p>
                    In any case, the Owner will gladly help to clarify the
                    specific legal basis that applies to the processing, and in
                    particular whether the provision of Personal Data is a
                    statutory or contractual requirement, or a requirement
                    necessary to enter into a contract.
                  </p>
                  <h3 className="atl-subheading atl-subheading-legal-place">
                    Place
                  </h3>
                  <p>
                    The Data is processed at the Owner's operating offices and
                    in any other places where the parties involved in the
                    processing are located<br /><br />
                    Depending on the User's location, data transfers may involve
                    transferring the User's Data to a country other than their
                    own. To find out more about the place of processing of such
                    transferred Data, Users can check the section containing
                    details about the processing of Personal Data.
                  </p>
                  <p>
                    If broader protection standards are applicable, Users are
                    also entitled to learn about the legal basis of Data
                    transfers to a country outside the European Union or to any
                    international organization governed by public international
                    law or set up by two or more countries, such as the UN, and
                    about the security measures taken by the Owner to safeguard
                    their Data <br /><br />
                    If any such transfer takes place, Users can find out more by
                    checking the relevant sections of this document or inquire
                    with the Owner using the information provided in the contact
                    section.
                  </p>
                  <h3 className="atl-subheading atl-subheading-legal-time">
                    Retention time
                  </h3>
                  <p>
                    Personal Data shall be processed and stored for as long as
                    required by the purpose they have been collected for.
                  </p>
                  <p>Therefore:</p>
                  <ul>
                    <li>
                      Personal Data collected for purposes related to the
                      performance of a contract between the Owner and the User
                      shall be retained until such contract has been fully
                      performed.
                    </li>
                    <li>
                      Personal Data collected for the purposes of the Owner’s
                      legitimate interests shall be retained as long as needed
                      to fulfill such purposes. Users may find specific
                      information regarding the legitimate interests pursued by
                      the Owner within the relevant sections of this document or
                      by contacting the Owner.
                    </li>
                  </ul>
                  <p>
                    The Owner may be allowed to retain Personal Data for a
                    longer period whenever the User has given consent to such
                    processing, as long as such consent is not withdrawn.
                    Furthermore, the Owner may be obliged to retain Personal
                    Data for a longer period whenever required to do so for the
                    performance of a legal obligation or upon order of an
                    authority <br /><br />
                    Once the retention period expires, Personal Data shall be
                    deleted. Therefore, the right of access, the right to
                    erasure, the right to rectification and the right to data
                    portability cannot be enforced after expiration of the
                    retention period.
                  </p>
                </div>

                <div className="one_line_col">
                  <h2 id="use_collected_data" className="pb-10">The purposes of processing</h2>
                  <p>
                    The Data concerning the User is collected to allow the Owner
                    to provide its Service, comply with its legal obligations,
                    respond to enforcement requests, protect its rights and
                    interests (or those of its Users or third parties), detect
                    any malicious or fraudulent activity, as well as the
                    following: User database management, Analytics,
                    Location-based interactions, Contacting the User, Handling
                    activity data, Hosting and backend infrastructure,
                    Infrastructure monitoring, Platform services and hosting,
                    Registration and authentication, Device permissions for
                    Personal Data access, Managing contacts and sending messages
                    and Content performance and features testing (A/B testing).
                  </p>

                  <p>
                    For specific information about the Personal Data used for
                    each purpose, the User may refer to the section “Detailed
                    information on the processing of Personal Data”. .
                  </p>
                </div>

                <div className="one_line_col">
                  <h2 id="mobile_permissions" className="pb-10">
                    Device permissions for Personal Data access
                  </h2>
                  <p>
                    Depending on the User's specific device, , AES Driver
                    Application may request certain permissions that allow it to
                    access the User's device Data as described below.
                  </p>
                  <p>
                    By default, these permissions must be granted by the User
                    before the respective information can be accessed. Once the
                    permission has been given, it can be revoked by the User at
                    any time. In order to revoke these permissions, Users may
                    refer to the device settings or contact the Owner for
                    support at the contact details provided in the present
                    document. <br />The exact procedure for controlling app
                    permissions may be dependent on the User's device and
                    software.
                  </p>
                  <p>
                    Please note that the revoking of such permissions might
                    impact the proper functioning of Atlas Energy Solutions .
                  </p>
                  <p>
                    If User grants any of the permissions listed below, the
                    respective Personal Data may be processed (i.e accessed to,
                    modified or removed) by Atlas Energy Solutions .
                  </p>
                  <h3
                    className="atl-subheading atl-subheading-pda-permission-14961282"
                  >
                    Approximate location permission (continuous)
                  </h3>
                  <p>
                    Used for accessing the User's approximate device location.
                    AES Driver Application may collect, use, and share User
                    location Data in order to provide location-based services.
                  </p>

                  <h3
                    className="atl-subheading atl-subheading-pda-permission-14961283"
                  >
                    Motion sensors permission
                  </h3>
                  <p>
                    Used for accessing the User's device motion sensors to
                    measure the User's activity such as step counts, stairs
                    climbed, and movement type (walking, cycling, etc.).
                  </p>

                  <h3
                    className="atl-subheading atl-subheading-pda-permission-14961281"
                  >
                    Precise location permission (continuous)
                  </h3>
                  <p>
                    Used for accessing the User's precise device location. AES
                    Driver Application may collect, use, and share User location
                    Data in order to provide location-based services.
                  </p>
                </div>

                <div data-locale="en"></div>

                <div className="one_line_col">
                  <h2 id="data_processing_detailed_info">
                    Detailed information on the processing of Personal Data
                  </h2>
                  <p className="pt-15">
                    Personal Data is collected for the following purposes and
                    using the following services:
                  </p>

                  <button id="phone_contact" className='accordion' onClick={toggleAccordion} >Phone contact</button>
                  <div className="panel">
                    <p>
                      Users that provided their phone number will get messages for authenticating to application through One Time password . Personal Data processed: email address; first name; last name; phone number. 
                    </p>
                    <p>
                      AES Driver Application requests certain permissions from Users that allow it to access the User's device Data as described below. 
                    </p>
                  </div>

                  <button id="device_permissions" className='accordion' onClick={toggleAccordion}>
                    Device permissions for Personal Data access
                  </button>
                  <div className="panel">
                    <p>
                      AES Driver Application requests certain permissions from Users that allow it to access the User's device Data as summarized here and described within this document. 
                    </p>
                    <p>
                      Personal Data processed: Approximate location permission (continuous); Motion sensors permission; Precise location permission (continuous). 
                    </p>

                    </div>

                    <button id="handling_activity" className='accordion' onClick={toggleAccordion} >
                     Handling activity data
                    </button>
                    <div className="panel">
                    <p>
                      This type of service allows the Owner to use the activity data collected by your device in order for AES Driver application to operate or to provide specific features. This may include movements and change in altitude. Most devices allow for the User to control which Data is accessed or stored. Activity data tracked by your device (AES Driver Application)
is only  for detecting the direction of movement .

                    </p>
                    <p>Personal Data processed: movement activity for driving directions . </p>

            
                    

                    
                  </div>
                  <button id="hosting_backend" className="accordion" onClick={toggleAccordion}>
                    Hosting and backend infrastructure
                  </button>
                  <div className="panel">
                    <div className="wrap">
                      <p>This type of service has the purpose of hosting data and files that enable Atlas Energy Solutions to run and be distributed as well as to provide a ready-made infrastructure to run specific features or parts of Atlas Energy Solutions. Some of these services work through geographically distributed servers, making it difficult to determine the actual location where the Personal Data are stored. </p>
                      
                      <h4 className="atl-service atl-service-2094091">
                        Azure Cloud Storage
                      </h4>
                      <p>
                        Azure Cloud Storage is a hosting service provided by
                        Microsoft.
                      </p>
                    </div>
                    <p>
                      Personal Data processed: various types of Data as
                      specified in the privacy policy of the service.
                    </p>

                    <p>
                      Place of processing: US &ndash;
                      <a
                        href="https://azure.microsoft.com/en-us/explore/trusted-cloud/privacy/"
                        target="_blank"
                        rel="noopener noreferrer"
                        >Privacy Policy</a
                      >.
                    </p>

                    <h4 className="atl-service atl-service-2094093">
                      Microsoft Azure Services
                    </h4>
                    <p>
                      Microsoft Azure Services is a hosting and backend
                      service provided by Microsoft.
                    </p>
                    <p>
                      Personal Data processed: various types of Data as
                      specified in the privacy policy of the service.
                    </p>
                    

                  </div>

                  <button id="registration_authentication" className="accordion" onClick={toggleAccordion}>
                    Registration and authentication
                  </button>
                  <div className="panel">
                    <p>
                      By registering or authenticating, Users allow Atlas Energy Solutions to identify them and give them access to dedicated services.
Depending on what is described below, third parties may provide registration and authentication services. In this case, Atlas Energy Solutions will be able to access some Data, stored by these third party services, for registration or identification purposes.
                    </p>
                    <h4 className="atl-service atl-service-2094093">Direct registration</h4>
                    <div className="wrap">
                      <p>
                        The User registers by filling out the registration form
                        and providing the Personal Data directly to Atlas Energy
                        Solutions.
                      </p>
                    </div>

                    <p>
                      Personal Data processed: email address; first name; last
                      name;
                    </p>

                    <h4 className="atl-service atl-service-2094091">Microsoft Azure B2C Authentication</h4>

                    <p>
                      user profiles by starting from an email address, a
                      personal name, or other information that the User provides
                      to Atlas Energy Solutions, as well as to track User
                      activities through analytics features. Some services may
                      also enable the sending of timed messages to the User such
                      as SMS based on specific actions performed on Atlas Energy
                      Solutions.
                    </p>

                    <p>
                      Personal Data processed: first name; last name; password;
                      phone number
                    </p>

                    <p>
                      Place of processing: United States &ndash;
                      <a
                        href="https://azure.microsoft.com/en-us/explore/trusted-cloud/privacy/"
                        target="_blank"
                        rel="noopener noreferrer"
                        >Privacy Policy</a
                      >.
                    </p>
                  

                  </div>
                </div>

                <div data-locale="en"></div>

                <div className="one_line_col">
                  <h2 id="further_data">
                    Further information about the processing of Personal Data
                  </h2>
                 <p>
                  Atlas Energy Solutions may send push notifications to the User. 
                 </p>
                 <p>
                  Users declare themselves to be adult according to their applicable legislation. Minors may use Atlas Energy Solutions only with the assistance of a parent or guardian. Under no circumstance persons under the age of 13 may use Atlas Energy Solutions.
                 </p>
                  
                </div>

                <div className="one_line_col">
                  <h2 id="rights_subjects" className="pb-10">The rights of Users</h2>
                  <p>
                    Users may exercise certain rights regarding their Data
                    processed by the Owner.
                  </p>
                  <p>
                    Users entitled to broader protection standards may exercise
                    any of the rights described below. In all other cases, Users
                    may inquire with the Owner to find out which rights apply to
                    them.
                  </p>
                  <p>
                    In particular, Users have the right to do the following:
                  </p>

                  <ul>
                    <li>
                      <strong>Withdraw their consent at any time.</strong> Users
                      have the right to withdraw consent where they have
                      previously given their consent to the processing of their
                      Personal Data.
                    </li>
                    <li>
                      <strong>Object to processing of their Data.</strong> Users
                      have the right to object to the processing of their Data
                      if the processing is carried out on a legal basis other
                      than consent. Further details are provided in the
                      dedicated section below.
                    </li>
                    <li>
                      <strong>Access their Data.</strong> Users have the right
                      to learn if Data is being processed by the Owner, obtain
                      disclosure regarding certain aspects of the processing and
                      obtain a copy of the Data undergoing processing.
                    </li>
                    <li>
                      <strong>Verify and seek rectification.</strong> Users have
                      the right to verify the accuracy of their Data and ask for
                      it to be updated or corrected.
                    </li>
                    <li>
                      <strong>Restrict the processing of their Data.</strong>
                      Users have the right, under certain circumstances, to
                      restrict the processing of their Data. In this case, the
                      Owner will not process their Data for any purpose other
                      than storing it.
                    </li>
                    <li>
                      <strong
                        >Have their Personal Data deleted or otherwise
                        removed.</strong
                      >
                      Users have the right, under certain circumstances, to
                      obtain the erasure of their Data from the Owner.
                    </li>
                    <li>
                      <strong
                        >Receive their Data and have it transferred to another
                        controller.</strong
                      >
                      Users have the right to receive their Data in a
                      structured, commonly used and machine readable format and,
                      if technically feasible, to have it transmitted to another
                      controller without any hindrance. This provision is
                      applicable provided that the Data is processed by
                      automated means and that the processing is based on the
                      User's consent, on a contract which the User is part of or
                      on pre-contractual obligations thereof.
                    </li>
                    <li>
                      <strong>Lodge a complaint.</strong> Users have the right
                      to bring a claim before their competent data protection
                      authority.
                    </li>
                  </ul>

                  <h3
                    className="atl-subheading atl-subheading-legal-right-to-object"
                  >
                    Details about the right to object to processing
                  </h3>
                  <p>
                    Where Personal Data is processed for a public interest, in
                    the exercise of an official authority vested in the Owner or
                    for the purposes of the legitimate interests pursued by the
                    Owner, Users may object to such processing by providing a
                    ground related to their particular situation to justify the
                    objection.
                  </p>
                  <p>
                    Users must know that, however, should their Personal Data be
                    processed for direct marketing purposes, they can object to
                    that processing at any time without providing any
                    justification. To learn, whether the Owner is processing
                    Personal Data for direct marketing purposes, Users may refer
                    to the relevant sections of this document.
                  </p>

                  <h3
                    className="atl-subheading atl-subheading-legal-how-to-exercise"
                  >
                    How to exercise these rights
                  </h3>
                  <p>
                    Any requests to exercise User rights can be directed to the
                    Owner through the contact details provided in this document.
                    These requests can be exercised free of charge and will be
                    addressed by the Owner as early as possible and always
                    within one month.
                  </p>
                </div>

                <div className="one_line_col">
                  <h2 id="further_data_processing_info">
                    Additional information about Data collection and processing
                  </h2>
                  <h3 className="atl-subheading atl-subheading-legal-protection">
                    Legal action
                  </h3>
                  <p>
                    The User's Personal Data may be used for legal purposes by
                    the Owner in Court or in the stages leading to possible
                    legal action arising from improper use of Atlas Energy
                    Solutions or the related Services.<br />The User declares to
                    be aware that the Owner may be required to reveal personal
                    data upon request of public authorities.
                  </p>
                  <h3 className="atl-subheading atl-subheading-legal-specific-info">
                    Additional information about User's Personal Data
                  </h3>
                  <p>
                    In addition to the information contained in this privacy
                    policy, Atlas Energy Solutions may provide the User with
                    additional and contextual information concerning particular
                    Services or the collection and processing of Personal Data
                    upon request.
                  </p>
                  <h3 className="atl-subheading atl-subheading-legal-maintenance">
                    System logs and maintenance
                  </h3>
                  <p>
                    For operation and maintenance purposes, Atlas Energy
                    Solutions and any third-party services may collect files
                    that record interaction with Atlas Energy Solutions (System
                    logs) or use other Personal Data (such as the IP Address)
                    for this purpose.
                  </p>
                  

                  <h3
                    className="atl-subheading atl-subheading-legal-changes-to-this-privacy-policy"
                  >
                    Changes to this privacy policy
                  </h3>
                  <p>
                    The Owner reserves the right to make changes to this privacy
                    policy at any time by notifying its Users on this page and
                    possibly within Atlas Energy Solutions and/or - as far as
                    technically and legally feasible - sending a notice to Users
                    via any contact information available to the Owner. It is
                    strongly recommended to check this page often, referring to
                    the date of the last modification listed at the bottom.
                    <br /><br />
                    Should the changes affect processing activities performed on
                    the basis of the User’s consent, the Owner shall collect new
                    consent from the User, where required.
                  </p>
                </div>

                <div className="one_line_col">
                  <h2 id="atlas_energy_solutions">Atlas Energy Solutions</h2>
                  <div className="box_primary box_10">
                    <button id="definitions_and_legal_references" onClick={toggleAccordion} className="accordion w_icon_24 bbm-0 icon_ribbon">
                        Definitions and legal references
                      </button>
                    <div className="panel tablepadding">
                      <h4>Personal Data (or Data)</h4>
                      <p>
                        Any information that directly, indirectly, or in
                        connection with other information — including a personal
                        identification number — allows for the identification or
                        identifiability of a natural person.
                      </p>

                      <h4>Usage Data</h4>
                      <p>
                        Information collected automatically through Atlas Energy
                        Solutions (or third-party services employed in Atlas
                        Energy Solutions), which can include: the IP addresses
                        or domain names of the computers utilized by the Users
                        who use Atlas Energy Solutions, the URI addresses
                        (Uniform Resource Identifier), the time of the request,
                        the method utilized to submit the request to the server,
                        the size of the file received in response, the numerical
                        code indicating the status of the server's answer
                        (successful outcome, error, etc.), the country of
                        origin, the features of the browser and the operating
                        system utilized by the User, the various time details
                        per visit (e.g., the time spent on each page within the
                        Application) and the details about the path followed
                        within the Application with special reference to the
                        sequence of pages visited, and other parameters about
                        the device operating system and/or the User's IT
                        environment.
                      </p>

                      <h4>User</h4>
                      <p>
                        The individual using Atlas Energy Solutions who, unless
                        otherwise specified, coincides with the Data Subject.
                      </p>

                      <h4>Data Subject</h4>
                      <p>
                        The natural person to whom the Personal Data refers.
                      </p>

                      <h4>Data Processor (or Data Supervisor)</h4>
                      <p>
                        The natural or legal person, public authority, agency or
                        other body which processes Personal Data on behalf of
                        the Controller, as described in this privacy policy.
                      </p>

                      <h4>Data Controller (or Owner)</h4>
                      <p>
                        The natural or legal person, public authority, agency or
                        other body which, alone or jointly with others,
                        determines the purposes and means of the processing of
                        Personal Data, including the security measures
                        concerning the operation and use of Atlas Energy. The
                        Data Controller, unless otherwise specified, is the
                        Owner of Atlas Energy Solutions.
                      </p>

                      <h4>Atlas Energy Solutions (or this Application)</h4>
                      <p>
                        The means by which the Personal Data of the User is
                        collected and processed.
                      </p>

                      <h4 className="atl-service atl-service-2094091">
                        During registration
                      </h4>

                      <p>
                        AES Driver application does not collect any other Personal details other than details collected during registration . If the user want to be anonymous , he/she can provide any name of his choice . Email ID/ Mobile number  is required for authentication/OTP verification purpose only .
                      </p>
                      <hr />
                      <h4>Legal information</h4>
                      <p>
                        This privacy policy relates solely to Atlas Energy
                        Solutions, if not stated otherwise within this document.
                      </p>
                      <div className="atl_footer">
                        <p>Latest update: March 16, 2023</p>
                      </div>
                    </div>
                  </div>
                </div>
          
              </div>
              
            </div>
           
          </div>
         
        </div>
      <div className="sidebar">
        <ul id="alllinks">
          <li>
            <a href="#privacy_policy" className={isActive == '#privacy_policy' ? 'hlink active': 'hlink'} onClick={toggleClass}>
              <span className="item"
                >Privacy Policy of Atlas Energy Solutions
              </span>
            </a>
          </li>
          <li>
            <a href="#owner_of_the_data" className={isActive == '#owner_of_the_data' ? 'hlink active': 'hlink'} onClick={toggleClass}>
              <span className="item">Owner and Data Controller </span>
            </a>
          </li>
          <li>
            <a href="#types_of_data" className={isActive == '#types_of_data' ? 'hlink active': 'hlink'} onClick={toggleClass}>
              <span className="item">Types of Data collected </span>
            </a>
          </li>
          <li>
            <a href="#place_of_processing" className={isActive == '#place_of_processing' ? 'hlink active': 'hlink'} onClick={toggleClass}>
              <span className="item">Mode and place of processing the Data </span>
            </a>
          </li>
          <li>
            <a href="#use_collected_data" className={isActive == '#use_collected_data' ? 'hlink active': 'hlink'} onClick={toggleClass}>
              <span className="item">The purposes of processing </span>
            </a>
          </li>
          <li>
            <a href="#mobile_permissions" className={isActive == '#mobile_permissions' ? 'hlink active': 'hlink'} onClick={toggleClass}>
              <span className="item"
                >Device permissions for Personal Data access
              </span>
            </a>
          </li>
          <li>
            <a href="#data_processing_detailed_info" className={isActive == '#data_processing_detailed_info' ? 'hlink active': 'hlink'} onClick={toggleClass}>
              <span className="item"
                >Detailed information on the processing of Personal Data
              </span>
            </a>
          </li>
          <li>
            <a href="#further_data" className={isActive == '#further_data' ? 'hlink active': 'hlink'} onClick={toggleClass}>
              <span className="item"
                >Further information about the processing of Personal Data
              </span>
            </a>
          </li>
          <li>
            <a href="#rights_subjects" className={isActive == '#rights_subjects' ? 'hlink active': 'hlink'} onClick={toggleClass}>
              <span className="item">The rights of Users </span>
            </a>
          </li>

          <li>
            <a href="#further_data_processing_info" className={isActive == '#further_data_processing_info' ? 'hlink active': 'hlink'} onClick={toggleClass}>
              <span className="item"
                >Additional information about Data collection and processing
              </span>
            </a>
          </li>

          <li>
            <a href="#atlas_energy_solutions" className={isActive == '#atlas_energy_solutions' ? 'hlink active': 'hlink'} onClick={toggleClass}>
              <span className="item"
                >Atlas Energy Solutions 
              </span>
            </a>
          </li>
          
          
        </ul>
      </div>
      </div>
    </div>
  );
};

export default Privacy;
